import React from 'react'
import { Container } from 'react-bootstrap'
import { Link } from 'react-router-dom'


const ProjectDetail1 = () => {
  return (
   <Container fluid className='project-section'>
    <div className='project-photo'>
        <div>
        <img className='img-fluid' src="https://i.ibb.co/kJxBZhy/Screen-Shot-Tool-20221211190706.png" alt="Screen-Shot-Tool-20221211190706" border="0"/>
        </div>
        <div >
        <img className='img-fluid ' src="https://i.ibb.co/6yd2j4C/Screen-Shot-Tool-20221211190639.png" alt="Screen-Shot-Tool-20221211190639" border="0"/>
        </div>
        <div >
        <img className='img-fluid ' src="https://i.ibb.co/XZH7ftz/Screen-Shot-Tool-20221211190610.png" alt="Screen-Shot-Tool-20221211190610" border="0"/>
        </div>
    </div>

    <div className='my-5 w-75 mx-auto text-white '>
               <h1>Project Description</h1>
               <p >This is Project of Learning new technologies like C++ ,C# ,Pyhton,Backend Programming With Php,One can Download Course Module and See How Many people purchased This Course </p>
               <ul className='text-strat'>
                 <li>This is a User Friendly </li>
                 <li>Secure User Authentication </li> 
                 <li>Recharts is Used To show data of How Many people Purchased A particula Course </li> 
                 <li>React Hot Toast Is Used For Assuring User Of Any Task</li>
                 <li>User Can see the Details of Instructor </li>
                 <li>USer can also Download the Course Module</li>
                 <li>Private Route Is used to secure resist unwanted people</li>
               </ul>
               <div>
                <a className='btn btn-primary mx-1' target={"_blank"} href="https://master-programming-e5574.firebaseapp.com">Live Site</a>
                <a className='btn btn-primary mx-1' target={"_blank"} href ="https://github.com/lalon147/master-programming-project">Client Side Link</a>
                <a className='btn btn-primary mx-1' target={"_blank"} href ="https://github.com/lalon147/master-programming-server">Server Side Link</a>
               </div>
    </div>
              

   </Container>
  )
}

export default ProjectDetail1